module.exports = __webpack_public_path__ + "img/矩形 83@1x.f5af7015.png";